import React from "react";
import { useSelector } from "react-redux";

import styles from "./TaxWithholding.module.scss";

import Button from "../../components/Button/Button";
import StateDisclosureContent from "../../components/StateDisclosureContent/StateDisclosureContent";
import { getModalProps } from "../../redux/modules/modals/modals.selectors";
import { STATES_DISCLOSURE_NOTES_MODAL } from "../../redux/modules/modals/modals.module";

const StateDisclosureContentModal = ({ onClose }) => {
  const modalProps = useSelector(getModalProps);
  const stateType = modalProps[STATES_DISCLOSURE_NOTES_MODAL].stateType;
  const stateName = modalProps[STATES_DISCLOSURE_NOTES_MODAL].stateName;
  const percentage = modalProps[STATES_DISCLOSURE_NOTES_MODAL].percentage;
  return (
    <div className={styles["tax-modal-container"]}>
      <StateDisclosureContent
        stateType={stateType}
        stateName={stateName}
        percentage={percentage}
      />
      <div className={styles["disclosure-button"]} onClick={onClose}>
        <Button
          id="close-state-disclosure-modal"
          type="primary"
          size="small"
        >
          OK
        </Button>
      </div>
    </div>
  );
};

export default StateDisclosureContentModal;
